const {bind} = require('../lib/bind')
const {Post} = require('../lib/ajax')
const Poll = require('./poll')

class Process {
  constructor(upload) {
    this.upload = upload
    this.form = document.querySelector('.js-talk-form')

    this.register()
  }

  register() {
    const url = `${this.form.action}.json`
    const formData = new FormData(this.form)
    formData.append('talk[pdf_filename]', this.upload.filenameFromKey())
    formData.delete('talk[name]')
    formData.delete('talk[description]')
    formData.delete('talk[category_id]')
    formData.delete('talk[formatted_published_at]')
    formData.delete('talk[view_policy]')

    this.talkRequest = new Post(url, {
      data: formData,
      success: this.onSuccess.bind(this),
      error: this.onError.bind(this)
    })
  }

  onSuccess(response) {
    const location = this.talkRequest.getResponseHeader('Location')
    const method = document.createElement('input')
    const statusUrl = location.replace(/\/edit$/, '/status')
    method.type = 'hidden'
    method.name = '_method'
    method.value = 'PUT'

    this.uuid = response.uuid
    this.form.action = location.replace(/\/edit$/, '')
    this.form.appendChild(method)
    this.upload.hideElement()
    new Poll(statusUrl)

    if ('pushState' in history) { history.pushState({}, false, location); }
  }

  onError() {
    // TODO: Make this work
  }
}

module.exports = Process
